import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

interface Context {
  id: string;
  text: string;
}

// Interface for the search result
interface SearchResult {
  id: string;
  text: string;
  context: Context[];
}

// Refactor result type
interface RefactorResult {
  text: string;
  pincode: number;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
// @ts-nocheck
export const refactor = (
  searchData: {
    context: {
      id: string;
      text: string;
    }[];
  }[]
) => {
  const arr: { text: string; pincode: number; id: string }[] = [];

  searchData?.map((data) => {
    const context = data.context;
    const city: string =
      context.filter((item: { id: string; text: string }) =>
        item.id.includes("place")
      )[0]?.text ?? "";
    const state: string =
      context.filter((item: { id: string; text: string }) =>
        item.id.includes("region")
      )[0]?.text ?? "";
    const pincode: number = parseInt(
      context.filter((item) => item.id.includes("postcode"))[0]?.text ?? "0"
    );

    if (city && state && pincode) {
      arr.push({
        text: `${city},${state},${pincode}`,
        pincode: pincode,
        id: JSON.stringify(pincode),
      });
    }
  });
  return arr;
};

// @ts-nocheck
export const refactorAffordability = (
  searchData: {
    context: { id: string; text: string }[];
    geometry: { coordinates: [number, number]; type: string };
  }[]
) => {
  const arr: {
    text: string;
    pincode: number;
    id: string;
    geometry: { coordinates: [number, number]; type: string };
  }[] = [];

  searchData?.forEach((data) => {
    const context = data.context;

    const city: string =
      context.filter((item: { id: string; text: string }) =>
        item.id.includes("place")
      )[0]?.text ?? "";
    const state: string =
      context.filter((item: { id: string; text: string }) =>
        item.id.includes("region")
      )[0]?.text ?? "";
    const pincode: number = parseInt(
      context.filter((item) => item.id.includes("postcode"))[0]?.text ?? "0"
    );

    if (city && state && pincode) {
      arr.push({
        text: `${city},${state},${pincode}`,
        pincode: pincode,
        id: JSON.stringify(pincode),
        geometry: data.geometry, // Include geometry for coordinates
      });
    }
  });
  return arr;
};


export function formatPropertyName(propertyName: string): string {
  return propertyName
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .replace(/\s+/g, "-");
}


export const formatCurrency = (value: number) => {
  const formattedValue = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0, // Ensures no decimal places if not needed
    maximumFractionDigits: 2, // Allows up to 2 decimal places when necessary
  }).format(value);

  return formattedValue.replace("$", ""); // Remove "$" if needed
};


export const formatProjectName = (projectName: string): string => {
  return projectName
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toLowerCase())
   .replace(/\s+/g, "-");  
}